import { StdVectorI8, StdVectorPoint3F, StdVectorU, TriMeshRayIntersector3F, } from '@seddi/wa-garments-geometry';
export const build = (indices, vertices) => {
    return new Promise(resolve => {
        const worker = new Worker(new URL('./workers/meshBvh.worker.ts', import.meta.url), {
            type: 'module',
        });
        worker.onmessage = (event) => {
            const bytes = event.data;
            worker.terminate();
            const pIntersectorIndices = new StdVectorU();
            pIntersectorIndices.resize(indices.length);
            pIntersectorIndices.data().set(indices);
            const pIntersectorVertices = new StdVectorPoint3F();
            pIntersectorVertices.resize(vertices.length / 3);
            pIntersectorVertices.data().set(vertices);
            const pBytes = new StdVectorI8();
            pBytes.resize(bytes.length);
            pBytes.data().set(bytes);
            const pIntersector = new TriMeshRayIntersector3F(pIntersectorIndices, pIntersectorVertices);
            pIntersector.load(pBytes);
            pBytes.delete();
            resolve({ pIntersector, pIntersectorIndices, pIntersectorVertices });
        };
        worker.postMessage({ indices: indices, vertices });
    });
};
export const dispose = (self) => {
    self.pIntersector.delete();
    self.pIntersectorIndices.delete();
    self.pIntersectorVertices.delete();
};
